import { useEffect, useState } from 'react'
import { LocalStorage } from '../LocalStorage'

export function useAuthToken() {
  const [authToken, setAuthToken] = useState<string | null>(null)

  useEffect(() => {
    const fetchAuthToken = async () => {
      const token = await LocalStorage.getAuthToken()
      setAuthToken(token)
    }

    void fetchAuthToken()
  }, [])

  return authToken
}
